export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10096.7a2f5433.jpg";